module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.b8214b99.png";